























import { eventBus } from "@/main";
import {
  DisplayModule,
  DocumentsModule,
  RouterModule,
  SectionsModule
} from "@/store/store.helper";
import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import * as enums from "@/types/enums";
import { Watch } from "vue-property-decorator";
import { colorDirective } from "@/directives/color-directive";
import { SECTION_STATUS } from '@/types/enums';

// The @Component decorator indicates the class is a Vue component
@Component({
  // All component options are allowed in here
  directives: {
    colorDirective
  },
  props: {
    pageStatus: Number,
    sectionIndex: Number,
    index: Number,
    sectionId: String,
    isInAddComponent: Boolean,
    sectionAcceptedAt: Date,
    sectionRejectedAt: Date,
    sectionsLength: Number,
    sectionTopic: String,
    isSwitched: Boolean,
    isEditFeed: Boolean,
    sectionStatus: Number,
  }
})
export default class CardTitle extends Vue {
  @DisplayModule.DisplayGetter private dateFormatted;
  @DocumentsModule.DocumentsGetter private documentDivisionOfTopics;
  @RouterModule.RouterGetter private currentRoute;
  @SectionsModule.SectionsGetter private sectionById;
  @RouterModule.RouterGetter private getPath;
  @RouterModule.RouterAction private push;
  @DisplayModule.DisplayMutation private setNavBar;

  private isSwitched;
  private sectionStatus;
  private mutedSwitch = this.sectionStatus === SECTION_STATUS.toEdit;
  private pageStatus;
  private sectionId;
  private sectionAcceptedAt;
  private sectionTopic;
  private enums = enums;
  private isEditFeed;
  private isParentFeed = false;

  @Watch("mutedSwitch")
  private onSwitchChange(newVal: any) {
    this.switchDisplays();
  }

  public switchDisplays() {
    eventBus.$emit("switchDisplays", this.sectionId);
  }

  public redirectToParentSection() {
    const parentSectionId = this.sectionById(this.sectionId)[0].parentSectionId;
    const parentSection = this.sectionById(parentSectionId)[0];
    parentSection.status === enums.SECTION_STATUS.approved
      ? this.routeToSectionPage(parentSectionId)
      : eventBus.$emit("goToSection", parentSectionId);
  }

  public routeToSectionPage(parentSectionId) {
    const path = this.getPath({
      name: enums.ROUTE_NAME.section,
      params: {
        [enums.SECTION_BY.sectionsByStatus]: enums.SECTION_STATUS.edited,
        id: parentSectionId
      }
    });
    this.setNavBar({ path: this.currentRoute.fullPath });
    this.push({ path });
  }

  private mounted() {
    if ('id' in this.$route.query) {
      // @ts-ignore
      this.isParentFeed = this.isEditFeed && this.$route.query.id === this.sectionId;
    }
    this.mutedSwitch = true;
  }
}
